import { render, staticRenderFns } from "./address-selection.vue?vue&type=template&id=20eb67da&"
import script from "./address-selection.vue?vue&type=script&lang=js&"
export * from "./address-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20eb67da')) {
      api.createRecord('20eb67da', component.options)
    } else {
      api.reload('20eb67da', component.options)
    }
    module.hot.accept("./address-selection.vue?vue&type=template&id=20eb67da&", function () {
      api.rerender('20eb67da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/templates/address-selection.vue"
export default component.exports